import { EventFilter, EventFilterConfig } from "@bryntum/schedulerpro";

export const eventFilterFeature = {
    disabled: false,
} satisfies Partial<EventFilterConfig> | EventFilter;
